import * as constants from '../components/Constants'
import cartBlack from '../assets/Icons/CART_BLACK.png'
import cartWhite from '../assets/Icons/CART_WHITE.png'
import cartPink from '../assets/Icons/CART_PINK.png'
import crossBlack from '../assets/Icons/CROSS_BLACK.png'
import crossWhite from '../assets/Icons/CROSS_WHITE.png'
import homePink from '../assets/Icons/HOME_PINK.png'
import lookAround from '../assets/Icons/360-ICON.png'
import { playClickSound } from './Sound'


export function CartBlack(props) {

  return (
    <div className='iconTopRight' onClick={() => { playClickSound(); props.updatePage(constants.REACT_PAGE_CART)}}>
      <img alt="" className={props.cartIconStatus ? 'iconImageChanged' : 'iconImage'} src={cartBlack}/>
      <div className='cartItemCounter' style={{color:'black'}}>{props.itemCount}</div>
    </div>
  )
}

export function CartWhite(props) {

  return (
    <div className='iconTopRight' onClick={() => { playClickSound(); props.updatePage(constants.REACT_PAGE_CART)}}>
      <img alt="" className={props.cartIconStatus ? 'iconImageChanged' : 'iconImage'} src={cartWhite}/>
      <div className='cartItemCounter' style={{color:'white'}}>{props.itemCount}</div>
    </div>
  )
}

export function CartPink(props) {

  return (
    <div className='iconTopRight' onClick={() => { playClickSound(); props.updatePage(constants.REACT_PAGE_CART)}}>
      <img alt="" className={props.cartIconStatus ? 'iconImageChanged' : 'iconImage'} src={cartPink}/>
      <div className='cartItemCounter' style={{color: '#d9b8b4'}}>{props.itemCount}</div>
    </div>
  )
}

export function HomePink(props) {

  return (
    <div className='iconTopLeft' onClick={() => {playClickSound() ; props.updatePage(constants.REACT_PAGE_MAIN)}}>
      <img alt="" className='iconImage' src={homePink}/>
    </div>
  )
}

export function CrossBlack(props) {

  return (
    <div className='iconTopLeft' onClick={() => { playClickSound(); props.setAlert(constants.ALERT_EXIT)}}>
      <img alt="" className='iconImage' src={crossBlack}/>
    </div>
  )
}

// In VTO, cross-> main screen, not exiting app.
export function CrossWhiteVTO(props) {

  return (
    <div className='iconTopLeft' onClick={() => {playClickSound(); props.updatePage(constants.REACT_PAGE_MAIN)}}>
      <img alt="" className='iconImage' src={crossWhite}/>
    </div>
  )
}


// On various screens, 360 prompt to look around.
export function LookAroundPrompt(props) {

  return (
    <div className='iconLookAround'>
      <img alt="" className='lookAroundImage' src={lookAround}/>
    </div>
  )
}

